export function CalcDiscount(discount, qty, price, isTotal=true) {
    const status = {
        success: false,
        message: "",
        result: 0
    };

    if (!discount || qty == null || price == null) {
        return { ...status, message: "missing data" };
    }

    if (isNaN(qty) || qty <= 0) {
        return { ...status, message: "please enter valid qty value (number)" };
    }

    if (isNaN(price) || price <= 0) {
        return { ...status, message: "please enter valid price value (number)" };
    }

    if (Object.keys(discount).length === 0) {
        return { ...status, message: "discount is empty" };
    }

    if (!["fixed", "percent"].includes(discount.discountType)) {
        return { ...status, message: "invalid discount type" };
    }

    let result = 0;

    if(!isTotal) {
        qty = 1;
    }

    if (discount.discountType === "fixed") {
        result = (price - discount.discountValue) * qty;
    }

    if (discount.discountType === "percent") {
        const discountedPrice =
            price - (price * discount.discountValue / 100);

        result = discountedPrice * qty;
    }

    return {
        ...status,
        result,
        success: true,
        message: "success"
    };
}